import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { mapActions } from "vuex"
import { loadMoreList } from "@/mixins/index";
import addApply from "./components/addApply";
export default {
  name: "applyList",
  mixins: [loadMoreList],
  components: {
    addApply: addApply
  },
  data: function data() {
    return {
      pagingReqFn: "appList",
      delIds: []
    };
  },
  activated: function activated() {
    this.getList();
  },
  methods: {
    // ...mapActions("d2admin/init", ["getDataList"]),
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    del: function del(dateList) {
      var _this = this;

      var ids = dateList.map(function (item) {
        return item.id;
      }).toString();
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'appListDel',
        data: {
          id: ids
        }
      }).then(function () {
        _this.getList(_this.paramsData.page);
      });
    }
  } // beforeRouteLeave(to, from, next) {
  //   this.getDataList('appListAllData')
  //   next()
  // },

};